import { SET_SEARCH_BLUR_CARDS_EMAIL } from './types';

/**
 * @module cache_action
 * @redux
 * @description These are redux action creators related to caching.
 */

/**
 * @function
 * @name saveSearchBlurCardsEmail
 * @description It's an action for saving email of the user entered on the [BlurCards]{@link BlurCards#postEmail} in redux.
 * @param {string} email - email of the user
 * @returns {Redux.Action} The generated action
 *
 * @example
 * console.log(saveSearchBlurCardsEmail(abc@gmail.com));
 * //It will dispatch an action like so: dispatch({ type: SET_SEARCH_BLUR_CARDS_EMAIL, payload: abc@gmail.com })
 */
export const saveSearchBlurCardsEmail = (email) => (dispatch) => {
  dispatch({ type: SET_SEARCH_BLUR_CARDS_EMAIL, payload: email });
};
